import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const LineSpacing = (props: SvgProps) => (
  <Svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 3H11M5 6H9.5M6 9H11"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 8.5L2.5 10M2.5 10L4 8.5M2.5 10V7"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 3L2.5 1.5M2.5 1.5L4 3M2.5 1.5V4.5"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default LineSpacing;
